var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F3E1E048-32FE-4607-B466-9496278E3C48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discursivas-detalhes/verde/editar",
    transform: "translate(-477.000000, -518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aula0",
    transform: "translate(312.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-edit",
    transform: "translate(165.000000, 186.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#83F367",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(3.000000, 2.000000)",
    fill: "#FF6A58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,17 C18.5522847,17 19,17.4477153 19,18 C19,18.5128358 18.6139598,18.9355072 18.1166211,18.9932723 L18,19 L9,19 C8.44771525,19 8,18.5522847 8,18 C8,17.4871642 8.38604019,17.0644928 8.88337887,17.0067277 L9,17 L18,17 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7928932,0.792893219 L0.292893219,13.2928932 C0.164734396,13.421052 0.0738156136,13.5816319 0.0298574999,13.7574644 L-0.9701425,17.7574644 C-1.15323762,18.4898448 -0.489844841,19.1532376 0.242535625,18.9701425 L4.24253563,17.9701425 C4.41836808,17.9261844 4.57894796,17.8352656 4.70710678,17.7071068 L17.2071068,5.20710678 C17.9956301,4.41858348 18.3035835,3.26928572 18.0149639,2.19214285 C17.7263444,1.11499998 16.885,0.27365563 15.8078572,-0.014963932 C14.7307143,-0.303583494 13.5814165,0.00436991264 12.7928932,0.792893219 Z M15.2902191,1.91688772 C15.6771778,2.020573 15.979427,2.32282219 16.0831123,2.70978094 L16.1097936,2.83951389 C16.1600815,3.18689073 16.0446919,3.54109458 15.7928932,3.79289322 L3.488,16.096 L1.374,16.625 L1.903,14.511 L14.2071068,2.20710678 C14.4589054,1.95530815 14.8131093,1.83991847 15.1604861,1.89020643 L15.2902191,1.91688772 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.25bbb6467e2acc64fcc0cc10b8569cd5.svg";
export { ForwardRef as ReactComponent };